import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";
import axios from "axios";
import { sanitizeText } from "../../../../utils/TextUtils";
import { BiDish, BiSolidDish } from "react-icons/bi";
import defaultImage from "../../../../utils/DefaultImage";
import TableLoader from "../../../../utils/TableLoader";
import PaginationComponent from "../../../../utils/PaginationComponent";
import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import MenuTimeSlotEdit from "./MenuTimeSlotEdit";

const MenuEdit = (props) => {
  const {
    menuData,
    setMenuData,
    isLoading,
    setIsLoading,
    handleSave,
    handleCancel,
    setSelectedDishes,
    selectedDishes,

    toggleStatus,
    setToggleStatus,
    statusValue,
    setStatusValue,
    states,

    editMenuDish,
    setEditMenuDish,


    days,
    activeDay,
    setActiveDay,
    timeSlots,
    setTimeSlots,
    handleTimeSlotChange,
    handleAddTimeSlot,
    handleRemoveTimeSlot,

    toggleSwitch
  } = props;

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [dishListData, setDishListData] = useState([]);

  const [loading, setLoading] = useState(false);

  const logoUrl = import.meta.env.VITE_BACKEND_APP_STORAGE_URL;

  const getDishListData = async () => {
    setLoading(true);
    try {
      const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
      const RestId = localStorage.getItem("currentRestId");
      const token = localStorage.getItem("token");
      let params;
      params = {
        pageNumber: page,
        size: rowsPerPage,
      };
      const response = await axios.get(`${apiUrl}/api/v1/restaurants/${RestId}/dishes`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        params,
      });

      const data = response?.data;
      setDishListData(data?.data);
      setTotalPages(data?.total);
    } catch (error) {
      console.error('Error fetching order data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (dish) => {
    setSelectedDishes((prevSelected) => {
      const isAlreadySelected = prevSelected.some((selectedDish) => selectedDish.id === dish.id);

      if (isAlreadySelected) {
        return prevSelected.filter((selectedDish) => selectedDish.id !== dish.id);
      } else {
        const selectedDishData = {
          id: dish.id,
          full_price: dish.full_price || "0.00",
          half_price: dish.half_price || "0.00",
          is_option_to_be_full_dish: dish.is_option_to_be_full_dish ? 1 : 0,
          is_option_to_be_half_dish: dish.is_option_to_be_half_dish ? 1 : 0,
        };
        return [...prevSelected, selectedDishData];
      }
    });
  };

  const handlePriceChange = (id, type, value) => {
    if (!/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    setDishListData((prevDishes) =>
      prevDishes.map((item) =>
        item.id === id ? { ...item, [type]: value } : item
      )
    );

    setEditMenuDish((prevDishes) =>
      prevDishes.map((item) =>
        item.id === id ? { ...item, [type]: value } : item
      )
    );


    setSelectedDishes((prevSelected) =>
      prevSelected.map((selectedDish) =>
        selectedDish.id === id ? { ...selectedDish, [type]: value } : selectedDish
      )
    );
  };

  const handleOnFullPrice = (id) => {
    setDishListData((prevDishes) =>
      prevDishes.map((item) =>
        item.id === id
          ? {
            ...item,
            is_option_to_be_full_dish: !item.is_option_to_be_full_dish,
            // full_price: !item.is_option_to_be_full_dish ? "" : item.full_price || "0.00",
          }
          : item
      )
    );

    setEditMenuDish((prevDishes) =>
      prevDishes.map((item) =>
        item.id === id
          ? {
            ...item,
            is_option_to_be_full_dish: !item.is_option_to_be_full_dish,
            // full_price: !item.is_option_to_be_full_dish ? "" : item.full_price || "0.00",
          }
          : item
      )
    );

    setSelectedDishes((prevSelected) =>
      prevSelected.map((selectedDish) =>
        selectedDish.id === id
          ? {
            ...selectedDish,
            is_option_to_be_full_dish: selectedDish.is_option_to_be_full_dish ? 0 : 1,
          }
          : selectedDish
      )
    );
  };

  const handleOnHalfPrice = (id) => {
    setDishListData((prevDishes) =>
      prevDishes.map((item) =>
        item.id === id
          ? {
            ...item,
            is_option_to_be_half_dish: !item.is_option_to_be_half_dish,
            // half_price: !item.is_option_to_be_half_dish ? "" : item.half_price || "0.00",
          }
          : item
      )
    );

    setEditMenuDish((prevDishes) =>
      prevDishes.map((item) =>
        item.id === id
          ? {
            ...item,
            is_option_to_be_half_dish: !item.is_option_to_be_half_dish,
            // half_price: !item.is_option_to_be_half_dish ? "" : item.half_price || "0.00",
          }
          : item
      )
    )

    setSelectedDishes((prevSelected) =>
      prevSelected.map((selectedDish) =>
        selectedDish.id === id
          ? {
            ...selectedDish,
            is_option_to_be_half_dish: selectedDish.is_option_to_be_half_dish ? 0 : 1,
          }
          : selectedDish
      )
    );
  };

  useEffect(() => {
    getDishListData();
  }, [page, rowsPerPage]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setToggleStatus(false)
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <>
      <section className="border-t border-[#D9D9D9] sm:mt-5 mt-0 pt-10">
        <div className="flex md:flex-row flex-col justify-between">
          <h3 className="text-3xl font-bold mb-2 poppins-medium  self-start">Modifica Menu</h3>
          <div className="flex items-center md:justify-end justify-start self-start gap-3 ">
            <label className="cursor-pointer">
              <input
                type="checkbox"
                checked={menuData.show_description === 1}
                onChange={() => toggleSwitch("show_description")}
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                        peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                        after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full 
                        after:transition-all peer-checked:bg-[#8B2433]">
              </div>
            </label>
            <span className="text-sm font-medium poppins-regular text-left">
              {menuData.show_description ? "Mostra Presentazione" : "Nascondi presentazione"}
            </span>
          </div>
        </div>

        <div className="w-full flex items-center my-5 justify-center flex-wrap">
          <div className="w-full grid md:grid-cols-2 gap-4 mb-[18px]">
            <div className="dropdown-main mb-3">
              <div className="relative group w-full bg-[#FFFFFF]">
                <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                  Nome Menu
                  <span className="text-red-500"> *</span>
                </label>
                <input
                  type="text"
                  placeholder="Nome Menu"
                  className="w-full flex justify-between poppins-medium items-center px-4 py-[17px] sm:text-sm text-[13px] text-[#8B8B8B] rounded-[28px] relative z-10 poppins-regular text-xs bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]
                  "
                  value={sanitizeText(menuData.name)}
                  onChange={(e) => setMenuData({ ...menuData, name: e.target.value })}
                />
              </div>
            </div>
            <div className="dropdown-main">
              <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                Stato:
              </label>
              <div className="relative group w-auto bg-[#FFFFFF] dropdown-container rounded-[28px]">
                <div className="border border-[#777777] rounded-[28px]">
                  <button
                    className="w-full flex justify-between poppins-medium items-center  px-4 py-[17px] sm:text-sm text-[13px] text-[#8B8B8B] rounded-[28px] cursor-pointer relative z-10 poppins-regular text-xs bg-transparent  focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    onClick={() => setToggleStatus(!toggleStatus)}
                  >
                    <span className="mr-2 flex items-center gap-3 poppins-medium">
                      {statusValue === "active" ? "Attivo" : statusValue === "inactive" ? "Inattivo" : "Scegli Stato"}
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${toggleStatus ? "rotate-180" : ""
                        }`}
                      size={"24px"}
                      color="#9f414f"
                    />
                  </button>
                  <div
                    className={`${toggleStatus ? "max-h-60 opacity-100 relative rounded-[28px] " : "max-h-0 opacity-0 overflow-hidden"
                      } bg-transparent absolute top-0  p-2 px-4 mt-0 rounded-[28px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                  >
                    {states
                      .filter((states) => states !== statusValue)
                      .map((states, index, array) => (
                        <label
                          key={states}
                          className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                          onClick={() => { setStatusValue(states); setToggleStatus(false) }}
                        >
                          <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                            {states === "active" ? "Attivo" : states === "inactive" ? "Inattivo" : ""}
                          </span>
                        </label>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full grid gap-4">
            <div className="relative group w-full bg-[#FFFFFF]">
              <div className="flex flex-col w-full gap-3">
                <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                  Descrizione
                  {/* <span className="text-red-500"> *</span> */}
                </label>
                <textarea
                  rows="4"
                  className="poppins-regular px-4 py-3 text-[16px]  text-[#8B8B8B] rounded-[14px]  bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(menuData.description)}
                  onChange={(e) => setMenuData({ ...menuData, description: e.target.value })}
                  placeholder="Descrizione"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <MenuTimeSlotEdit
            days={days}
            activeDay={activeDay}
            statusValue={statusValue}
            setStatusValue={setStatusValue}
            setActiveDay={setActiveDay}
            timeSlots={timeSlots}
            setTimeSlots={setTimeSlots}
            handleTimeSlotChange={handleTimeSlotChange}
            handleAddTimeSlot={handleAddTimeSlot}
            handleRemoveTimeSlot={handleRemoveTimeSlot}
          />
        </div>

      </section>

      <section>
        <div className="wine-main-stock w-auto h-auto bg-[#F8F8F8] border-[1.5px] border-[#8B24332B]
         text-[#303030] pt-3 pb-0 px-6 rounded-xl shadow">
          <table className="w-full text-left ristoranti_table">
            <thead>
              <tr className="border-b ">
                <th className="pb-3 pr-2 text-left poppins-medium"></th>
                <th className="pb-3 pr-2 text-left poppins-medium">Immagine</th>
                <th className="pb-3 px-2 text-left poppins-medium">Nome del piatto</th>
                <th className="pb-3 px-2 text-left poppins-medium">Descrizione</th>
                <th className="pb-3 px-2 text-left poppins-medium">Mostra Prezzi</th>
                <th className="pb-3 px-2 text-left poppins-medium">Prezzo Intero</th>
                <th className="pb-3 px-2 text-left poppins-medium">Prezzo Mezza Porzione</th>
              </tr>
            </thead>
            {loading ? (
              <TableLoader />
            ) : (
              <tbody>
                {dishListData && dishListData.length > 0 ? (
                  dishListData.map((item, index) => {
                    const editItem = editMenuDish.find((edit) => edit.id === item.id) || item;
                    return (
                      <tr key={index} className="border-b xxl:text-lg text-sm">
                        <td className="py-4 text-left poppins-regular">
                          <input
                            type="checkbox"
                            className="h-4 w-4 border rounded-md accent-[#8B2433] mr-2 poppins-regular"
                            checked={selectedDishes.some((selectedDish) => selectedDish.id === item.id)}
                            onChange={() => handleCheckboxChange(item)}
                          />
                        </td>

                        <td className="pr-2 py-4">
                          <div className="thumbnail_image rounded-lg w-[50px] h-[60px] p-1 flex align-center justify-center">
                            <img
                              className="w-10 h-10 rounded-full"
                              src={item?.picture ? `${logoUrl}/${item.picture}` : defaultImage}
                              alt="Dish"
                            />
                          </div>
                        </td>
                        <td className="py-4 px-2 text-left poppins-regular">{item?.name}</td>
                        <td className="py-4 px-2 text-justify poppins-regular">{item?.description}</td>
                        <td className="py-4 px-2 text-left poppins-regular">
                          <div className="flex flex-col items-center justify-center gap-2">
                            {/* Full Price Checkbox */}
                            <div className="flex items-center gap-2">
                              <div className="svg-icon h-[15.69px] w-[15.69px] bg-white">
                                <BiSolidDish className="w-4 h-4" color="#303030" />
                              </div>
                              <input
                                type="checkbox"
                                className="accent-[#8B2433] w-4 h-4 rounded-md"
                                checked={editItem.is_option_to_be_full_dish || false}
                                onChange={() => handleOnFullPrice(item.id)}
                              />
                            </div>

                            {/* Half Price Checkbox */}
                            <div className="flex items-center gap-2">
                              <div className="svg-icon h-[15px] w-[15px] bg-white">
                                <BiDish className="w-4 h-4" color="#303030" />
                              </div>
                              <input
                                type="checkbox"
                                className="accent-[#8B2433] w-4 h-4 rounded-md"
                                checked={editItem.is_option_to_be_half_dish || false}
                                onChange={() => handleOnHalfPrice(item.id)}
                              />
                            </div>
                          </div>
                        </td>
                        <td className="py-4 px-2 text-left poppins-regular">
                          <input
                            type="text"
                            placeholder="Scrivi qui"
                            className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                            value={editItem.full_price || ""}
                            onChange={(e) => handlePriceChange(item.id, "full_price", e.target.value)}
                          />

                          {/* {editItem.is_option_to_be_full_dish ? (
                            <input
                              type="text"
                              placeholder="Enter price"
                              className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                              value={editItem.full_price || ""}
                              onChange={(e) => handlePriceChange(item.id, "full_price", e.target.value)}
                            />
                          ) : (
                            <input
                              type="text"
                              className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                              value="0.00"
                              readOnly
                              style={{ cursor: "not-allowed" }}
                            />
                          )} */}
                        </td>
                        <td className="py-4 px-2 text-left poppins-regular">
                          <input
                            type="text"
                            placeholder="Scrivi qui"
                            className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                            value={editItem.half_price || ""}
                            onChange={(e) => handlePriceChange(item.id, "half_price", e.target.value)}
                          />
                          {/* {editItem.is_option_to_be_half_dish ? (
                            <input
                              type="text"
                              placeholder="Enter price"
                              className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                              value={editItem.half_price || ""}
                              onChange={(e) => handlePriceChange(item.id, "half_price", e.target.value)}
                            />
                          ) : (
                            <input
                              type="text"
                              className="w-[79px] h-[30px] rounded-[6px] border-black border-2 flex items-center justify-center pl-[5px] text-black text-[15px]"
                              value="0.00"
                              readOnly
                              style={{ cursor: "not-allowed" }}
                            />
                          )} */}
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="py-4 text-center">
                      No dishes found.
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>

        {dishListData && dishListData?.length > 0 && (
          <PaginationComponent
            page={page}
            totalPages={totalPages}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
          />
        )}

        <div className="flex text-sm sm:flex-row flex-col justify-start gap-4 mt-4">
          {isLoading.save ? (
            <button disabled type="button"
              className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
              <svg
                aria-hidden="true"
                className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              Loading...
            </button>
          ) : (
            <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
              onClick={handleSave}
              disabled={isLoading.save}
            >
              <TiTick size={"25px"} color="green" />
              <span className="poppins-regular">Aggiorna</span>
            </button>
          )}
          <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
            onClick={handleCancel}
          >
            <IoClose size={"25px"} color="red" className="group-hover:invert" />
            <span className="poppins-regular">Annulla</span>
          </button>
        </div>
      </section>
    </>
  );
};

MenuEdit.propTypes = {
  menuData: PropTypes.object.isRequired,
  setMenuData: PropTypes.func.isRequired,
  isLoading: PropTypes.object.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};
export default MenuEdit;